import { computed, reactive, toRefs } from 'vue'
import { useStore } from '@freebe/sdk/store'

export default function useStates() {
  const { get } = useStore('@admin/statistics/state')

  const state = reactive({
    usersState: computed(() => get({ type: 'users'})),

    total: computed(() => state.usersState.metadata.total || 0),
    active: computed(() => state.usersState.metadata.active || 0),
    blocked: computed(() => state.usersState.metadata.blocked || 0),
    removed: computed(() => state.usersState.metadata.removed || 0),
    unique: computed(() => state.usersState.metadata.unique || 0),
    trial: computed(() => state.usersState.metadata.trial || 0),
    freeActive: computed(() => state.usersState.metadata.free_active || 0),
    paidActive: computed(() => state.usersState.metadata.paid_active || 0),
    freeInactive: computed(() => state.usersState.metadata.free_inactive || 0),
    paidInactive: computed(() => state.usersState.metadata.paid_inactive || 0),
    paidInFree: computed(() => state.usersState.metadata.paid_in_free || 0),
    paidInSubscription: computed(() => state.usersState.metadata.paid_in_subscription || 0),
    churnRate: computed(() => state.usersState.metadata.churn_rate || 0),
    conversionRate: computed(() => state.usersState.metadata.conversion_rate || 0),
    conversionActiveRate: computed(() => state.usersState.metadata.conversion_active_rate || 0),

    billingState: computed(() => get({ type: 'billing'})),

    invoicesCount: computed(() => state.billingState.metadata.invoices_count || 0),
    invoicesAmount: computed(() => state.billingState.metadata.invoices_amount || 0),
    quotationsCount: computed(() => state.billingState.metadata.quotations_count || 0),
    quotationsAmount: computed(() => state.billingState.metadata.quotations_amount || 0),
    billsCount: computed(() => state.billingState.metadata.bills_count || 0),
    billsAmount: computed(() => state.billingState.metadata.bills_amount || 0),

    budgetState: computed(() => get({ type: 'budget'})),
    
    ca: computed(() => state.budgetState.metadata.ca || 0),
    tva: computed(() => state.budgetState.metadata.tva || 0),
  })

  return toRefs(state)
}
